module.exports = __webpack_public_path__ + "static/media/pequeno_prazer_2.206114c0.jpg";